import React from 'react';
import ReactDOM from 'react-dom';
import thunkMiddleware from 'redux-thunk';
import {createLogger} from 'redux-logger';
import CategoryMatching from './../components/CategoryMatching';
import {applyMiddleware, combineReducers, createStore} from 'redux';
import {Provider} from 'react-redux';
import category_matching from 'reducers/category_matching';
import api from 'reducers/api';
import {composeWithDevTools} from 'remote-redux-devtools';



export default () => {
	let element = document.getElementById('category_matching');
	if (element) {
		const loggerMiddleware = createLogger();
		const store = createStore(combineReducers({
			category_matching,
			api
		}), composeWithDevTools(applyMiddleware(thunkMiddleware, loggerMiddleware)));


			ReactDOM.render(<Provider store={store}>
				<CategoryMatching/>
			</Provider>, element);

	}
}



// WEBPACK FOOTER //
// ./frontend/apps/CategoryMatching.js